module.exports = __webpack_public_path__ + "static/media/water-work.46812302.ogv";